import { CSSObject } from "@emotion/react";

export const useStyles = () => {
  return {
    dialogContent: {
      alignItems: "flex-start",
      padding: "0 16px 16px 0",
      display: "flex",
      flexDirection: "column",
      minWidth: 0,
      maxWidth: "100%"
    },
    customBadge: {
      borderRadius: "4px",
      padding: "6px 8px",
      border: "none"
    },
    usedFiltersBlock: {
      padding: "16px 0 0 0",
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      rowGap: "4px",
      maxWidth: "100%",
      minWidth: 0
    }
  } as CSSObject;
};
